import request from '@/utils/request'

const AwardWinURL = {
  List: '/awards/list',
  Detail: '/awards/addressee-view',
  Update: '/awards/addressee-update',
  SureGrant: '/awards/give-out',
  Log: '/awards/show-log'
}

// 获奖列表
export function getListAwardWin (data) {
  return request({
    url: AwardWinURL.List,
    method: 'post',
    data
  })
}

// 获奖详情
export function getDetailAwardWin (data) {
  return request({
    url: AwardWinURL.Detail,
    method: 'post',
    data
  })
}

// 获奖收件人更新
export function updateAwardWin (data) {
  return request({
    url: AwardWinURL.Update,
    method: 'post',
    data
  })
}

// 获奖确认发放
export function SureGrantAwardWin (data) {
  return request({
    url: AwardWinURL.SureGrant,
    method: 'post',
    data
  })
}

// 获奖日志
export function LogAwardWin (data) {
  return request({
    url: AwardWinURL.Log,
    method: 'post',
    data
  })
}

export default {
  LogAwardWin,
  updateAwardWin,
  getListAwardWin,
  getDetailAwardWin,
  SureGrantAwardWin
}
